import type { ScreenSchema } from './types';
const graphSchema: ScreenSchema = {
  template: 'graph',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};
export default graphSchema;
